export function parentalPermissionsTypePatcher(data) {
    return {
        __typename: 'ParentalPermission',
        ...data,
    };
}
